import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate, Link } from 'react-router-dom';
import Logo from '../brand/Logo';
import apiService from '../../services/apiService';
import './Auth.css';

const SignIn = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { email: '', password: '' },
    validationSchema: Yup.object({
      // Accepts email or plain username (e.g. spacemonkey.admin)
      email: Yup.string().required('Required'),
      password: Yup.string().required('Required'),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        setError(null);

        // TEMPORARY LOGIN — REMOVE BEFORE GOING LIVE.
        // This hardcoded credential is a placeholder so the Space Monkey owner
        // can access the dashboard before backend auth exists. It MUST be
        // replaced with real Supabase Auth before launch. Do not ship this to
        // production as-is.
        const identifier = values.email.trim().toLowerCase();
        if (identifier === 'spacemonkey.admin' && values.password === '12345678') {
          localStorage.setItem('authToken', 'temp-space-monkey-owner-token');
          localStorage.setItem('accountType', 'space_monkey_owner');
          navigate('/spacemonkey/dashboard');
          return;
        }

        await apiService.signIn({ email: values.email, password: values.password });
        navigate('/admin/dashboard');
      } catch (err) {
        setError(err.message || 'Failed to sign in');
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="auth-page">
      <Link to="/" className="auth-logo-link">
        <Logo size="md" />
      </Link>

      <div className="auth-card">
        <h1 className="auth-card-title">Welcome back</h1>
        <p className="auth-card-sub">Sign in to your account</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={formik.handleSubmit} noValidate>
          <div className="auth-field">
            <label htmlFor="email">Email or Username</label>
            <input
              id="email"
              name="email"
              type="text"
              autoComplete="username"
              autoCapitalize="none"
              placeholder="you@example.com"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="auth-field-error">{formik.errors.email}</div>
            )}
          </div>

          <div className="auth-field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
            />
            {formik.touched.password && formik.errors.password && (
              <div className="auth-field-error">{formik.errors.password}</div>
            )}
          </div>

          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>

      <div className="auth-footer-link">
        Don't have an account? <Link to="/admin/signup">Sign Up</Link>
      </div>
    </div>
  );
};

export default SignIn;
